module.exports = __webpack_public_path__ + "static/vacuum-icon-3be081ec1b4698ac17ca3143d27cf058.svg";